export default __webpack_public_path__ + "static/media/earth-216834_1280_0.8ece26d4.jpg";